import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { BaseUnsubscribeComponent } from 'src/app/shared-new/components/base-unsubscribe/base-unsubscribe.component';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadFileComponent extends BaseUnsubscribeComponent {
  @Input() disabled: boolean = false;
  @Input() multiple: boolean = false;
  @Input() categoryName: string = '';
  @Input() isShowUpload: boolean = true;

  @Output() uploadFiles: EventEmitter<File[]> = new EventEmitter<File[]>();


  selectFiles(event: any): void {
    this.uploadFiles.emit([...event.target.files]);
  }

}
